import styled from 'styled-components'

export const ChecklistTransferModalTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 8px;
`

export const ChecklistTransferModalText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 16px;
`
